const RECEIVABLES_TABS = {
  MOVEMENTS: 'MOVEMENTS',
  COLLECT_LOCAL_PAYMENT: 'COLLECT_LOCAL_PAYMENT',
};

export default RECEIVABLES_TABS;
